<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="copyright-page" id="cip">
<p class="crtf"><span aria-label="iv" class="page" id="piv" role="doc-pagebreak"></span>The University of Chicago Press, Chicago 60637</p>
<p class="crt">The University of Chicago Press, Ltd., London</p>
<p class="crt">© 2020 by The University of Chicago</p>
<p class="crt">All rights reserved. No part of this book may be used or reproduced in any manner whatsoever without written permission, except in the case of brief quotations in critical articles and reviews. For more information, contact the University of Chicago Press, 1427 E. 60th St., Chicago, IL 60637.</p>
<p class="crt">Published 2020</p>
<p class="crt">Printed in the United States of America</p>
<p class="crtf">29 28 27 26 25 24 23 22 21 20    1 2 3 4 5</p>
<p class="crtf"><span class="sm">ISBN</span>-13: 978-0-226-67746-0 (cloth)</p>
<p class="crt"><span class="sm">ISBN</span>-13: 978-0-226-68539-7 (e-book)</p>
<p class="crt"><span class="sm">DOI</span>: <a class="url" href="https://doi.org/10.7208/chicago/9780226685397.001.0001" target="_blank">https://doi.org/10.7208/chicago/9780226685397.001.0001</a></p>
<p class="crtf">Originally published in French as <i>Geschlecht III. Sexe, race, nation, humanité</i> © Éditions du Seuil, 2018.</p>
<p class="crtf"><img alt="" height="139" src="images/logo-CNL-new-red.jpg" width="295"/></p>
<p class="crt"><a class="url" href="http://www.centrenationaldulivre.fr" target="_blank">www.centrenationaldulivre.fr</a></p>
<p class="cipf">Library of Congress Cataloging-in-Publication Data</p>
<p class="cipf">Names: Derrida, Jacques, author. | Bennington, Geoffrey, editor. | Chenoweth, Katie, editor, translator. | Therezo, Rodrigo, editor, translator.</p>
<p class="cip">Title: Geschlecht III : sex, race, nation, humanity / Jacques Derrida ; edited by Geoffrey Bennington, Katie Chenoweth, Rodrigo Therezo ; translated by Katie Chenoweth, Rodrigo Therezo.</p>
<p class="cip">Other titles: Geschlecht III. English</p>
<p class="cip">Description: Chicago : University of Chicago Press, 2020. | Includes bibliographical references and index.</p>
<p class="cip">Identifiers: <span class="sm">LCCN</span> 2019027816 | <span class="sm">ISBN</span> 9780226677460 (cloth) | <span class="sm">ISBN</span> 9780226685397 (ebook)</p>
<p class="cip">Subjects: <span class="sm">LCSH</span>: Heidegger, Martin, 1889–1976. | Sex—Anthropological aspects. | Sex—Political aspects.</p>
<p class="cip">Classification: <span class="sm">LCC</span> <span class="sm">B</span>3279.<span class="sm">H</span>49 <span class="sm">D</span>483813 2020 | <span class="sm">DDC</span> 193—dc23</p>
<p class="cip">LC record available at <a class="url" href="https://lccn.loc.gov/2019027816" target="_blank">https://lccn.loc.gov/2019027816</a></p>
<p class="crtf"><img alt="" height="12" src="images/infinity-symbol.jpg" width="12"/> This paper meets the requirements of <span class="sm">ANSI</span>/<span class="sm">NISO</span> <span class="sm">Z</span>39.48-1992 (Permanence of Paper).</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-derrida-geschlecht-0004.vue?68a588b2